import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Translation from "../../common/translation/translation.component";
import { USER_ROLES_ID as userRoles } from "../../../utils/constant.utils";

export class ModalFooterExhibit1 extends Component {
    render() {
        const { data, showRejectionCommentBox, closeAction
            , handleCancelRejectionClick
            , showConfirmationModal
            , showRejectConfirmationModal
            , approveAction
            , showDecisionButtons, canCancelOrder } = this.props;
        let RoleID = parseInt(sessionStorage.getItem('UserRoleID'), 10);
        var isApprover = (RoleID === userRoles.manager || RoleID === userRoles.lineManager || JSON.parse(sessionStorage.getItem('IsWireLineApprover')));
        var isForApproval = data != undefined ? data.Order != undefined ? data.Order.IsForApproval : false : false;
        return (
            <Modal.Footer>
                <Button variant="secondary" hidden={true} onClick={closeAction}>
                    <Translation translationKey="success_modal_button" />
                </Button>
                {
                    isApprover && isForApproval && showDecisionButtons ?
                        <>
                            {showRejectionCommentBox ?
                                <Button variant="secondary" onClick={handleCancelRejectionClick}>
                                    <Translation translationKey="discard_cancelBtn" />
                                </Button> : ""}
                            <Button variant="secondary" disabled={showRejectionCommentBox} onClick={showRejectConfirmationModal}>
                                <Translation translationKey="reject_button" />
                            </Button>
                            <Button variant="primary" onClick={approveAction}>
                                <Translation translationKey="approve_button" />
                            </Button>
                        </>

                        :

                        canCancelOrder &&
                        <Button variant="secondary" onClick={showConfirmationModal}>
                            <Translation translationKey="cancel_request_button" />
                        </Button>
                }
            </Modal.Footer>
        )
    }
}


export class ConfirmationModalFooter extends Component {
    render() {
        const { closeAction, confirmAction, disabled, closeLabel, confirmLabel } = this.props;
        return (
            <Modal.Footer>
                <Button variant="secondary" className={"left-footer-button"} onClick={closeAction}>
                    {closeLabel}
                </Button>

                <Button disabled={disabled} variant="primary" onClick={confirmAction} className={"right-footer-button"}>
                    {confirmLabel}
                </Button>
            </Modal.Footer>
        )
    }
}